import WS from '../ws'
/* eslint-disable */
export default class Api {
  constructor(timeout = 5e3, maxAttempts = 5) {
    this.timeout = timeout
    this.maxAttempts = maxAttempts
    this._publicBaseUrl = 'wss://fstream.binance.com/public/ws/'
    this._publicCombinedBaseUrl = 'wss://fstream.binance.com/public/stream?streams='
    this._marketBaseUrl = 'wss://fstream.binance.com/market/ws/'
    this._marketCombinedBaseUrl = 'wss://fstream.binance.com/market/stream?streams='
    this.subscription = {}
    this.streams = {
      depth: (symbol) => `${symbol.toLowerCase()}@depth`,
      depthLevel: (symbol, level) => `${symbol.toLowerCase()}@depth${level}`,
      kline: (symbol, interval) => `${symbol.toLowerCase()}@kline_${interval}`,
      aggTrade: (symbol) => `${symbol.toLowerCase()}@aggTrade`,
      trade: (symbol) => `${symbol.toLowerCase()}@trade`,
      ticker: (symbol) => `${symbol.toLowerCase()}@ticker`,
      miniTicker: (symbol) => `${symbol.toLowerCase()}@miniTicker`,
      allMiniTicker: () => `!miniTicker@arr`,
      allTickers: () => '!ticker@arr'
    }
    this._streamCategory = {
      depth: 'public',
      depthLevel: 'public',
      kline: 'market',
      aggTrade: 'market',
      trade: 'market',
      ticker: 'market',
      miniTicker: 'market',
      allMiniTicker: 'market',
      allTickers: 'market',
    }
  }

  _getBaseUrl(category, isCombined = false) {
    if (category === 'public') return isCombined ? this._publicCombinedBaseUrl : this._publicBaseUrl
    return isCombined ? this._marketCombinedBaseUrl : this._marketBaseUrl
  }

  subscribe(cb, endpoint, category = 'market', isCombined = false) {
    let ws;
    try {
      const baseUrl = this._getBaseUrl(category, isCombined)
      let path = baseUrl + endpoint;
      if (this.subscription[path]) {
        return this.subscription[path]
      }
      ws = new WS(path, {
        timeout: this.timeout,
        maxAttempts: this.maxAttempts,
        onopen: e => console.log('Connected!', e),
        onmessage: e => cb(JSON.parse(e.data)),
        onreconnect: e => console.log('Reconnecting...', e),
        onmaximum: e => console.log('Stop Attempting!', e),
        onclose: e => { console.log('Closed!', e); this.removeSubscription(e.endpoint) },
        onerror: e => console.log('Error:', e)
      });
      this.subscription[path] = ws
    }
    catch(ex) {
      console.log("Error :" + ex)
    }
  }

  caller(fname, ...args) {
    return this.streams[fname].call(null, ...args)
  }

  removeSubscription(endpoint) {
    if (this.subscription[endpoint]) {
      delete this.subscription[endpoint]
    }
  }

  closeSubscription(type, isCombined = false, ...args) {
    const endpoint = this.caller(type, ...args);
    const category = this._streamCategory[type] || 'market'
    const baseUrl = this._getBaseUrl(category, isCombined)
    const path = baseUrl + endpoint;
    const ws = this.subscription[path];
    if (ws) {
      ws.close(1000, "");
    }
  }

  closeAll() {
    for (const key in this.subscription) {
      this.subscription[key].close();
      delete this.subscription[key]
    }
    this.subscription = {}
  }

  onDepthUpdate(symbol, eventHandler) {
    return this.subscribe(eventHandler, this.streams.depth(symbol), 'public')
  }

  onDepthLevelUpdate(symbol, level, eventHandler) {
    return this.subscribe(eventHandler, this.streams.depthLevel(symbol, level), 'public')
  }

  onKline(symbol, interval, eventHandler) {
    return this.subscribe(eventHandler, this.streams.kline(symbol, interval), 'market')
  }

  onAggTrade(symbol, eventHandler) {
    return this.subscribe(eventHandler, this.streams.aggTrade(symbol), 'market')
  }

  onTrade(symbol, eventHandler) {
    return this.subscribe(eventHandler, this.streams.trade(symbol), 'market')
  }

  onTicker(symbol, eventHandler) {
    return this.subscribe(eventHandler, this.streams.ticker(symbol), 'market')
  }

  onMiniTicker(symbol, eventHandler) {
    return this.subscribe(eventHandler, this.streams.miniTicker(symbol), 'market')
  }

  onAllMiniTickers(eventHandler) {
    return this.subscribe(eventHandler, this.streams.allMiniTicker(), 'market')
  }

  onAllTickers(eventHandler) {
    return this.subscribe(eventHandler, this.streams.allTickers(), 'market')
  }

  onCombinedStream(streams, eventHandler) {
    return this.subscribe(eventHandler, streams.join('/'), 'market', true)
  }
}
